import React, { useMemo } from 'react'
import block from 'bem-cn'

import { JackpotNameTypes } from 'services/api/JackpotsApi/JackpotsConverter'

import { defaultCurrency } from 'shared/constants'
import { useOdometerFormat } from 'shared/hooks/useOdomterFormat'
import { localeSlotsType } from 'shared/locale/en-US'

import Odometer from 'components/Odometer'

import bronzeImage from '../img/bronze.webp'
import goldImage from '../img/gold.webp'
import silverImage from '../img/silver.webp'

import 'odometer/themes/odometer-theme-default.css'
import './JackpotItem.scss'

const b = block('jackpot-elem-d')

interface IJackpotItemProps {
  amount: number
  name: string
  locale: localeSlotsType
}

const images: Record<JackpotNameTypes, string> = {
  gold: goldImage,
  silver: silverImage,
  bronze: bronzeImage,
}

export const JackpotItem: React.FC<IJackpotItemProps> = ({ amount, name, locale }) => {
  const image = useMemo(() => images?.[name as JackpotNameTypes], [name])
  const { value, format, decimalStep } = useOdometerFormat(amount)

  return (
    <div className={b({ name })}>
      <div className={b('container')}>
        <div className={b('name')}>{locale?.[name as JackpotNameTypes]}</div>
        <div className={b('value')}>
          <div className={b('odometer-wrapper', { color: name })}>
            <Odometer value={value + decimalStep} format={format} />
            <span className={b('currency')}>{defaultCurrency}</span>
          </div>
        </div>
        <div className={b('image-wrapper')}>
          <img src={image} alt={name} className={b('image')} />
        </div>
      </div>
    </div>
  )
}
